import React from "react";
import AdPlaceholder from "./FreeAreaAdPlaceholder";
import GlobalFooter from "./GlobalFooter";
import LegacyFooter from "./Footer";

// Keep the placement outside the footer, exactly once per member content page.
export default function MemberAreaFooter({legacy=false}) {
  return <><div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-10"><AdPlaceholder/></div>{legacy?<LegacyFooter/>:<GlobalFooter/>}</>;
}
